<div class="col-12 whiteBg manageEmailTemplate">
    <div class="row">
        <div class="col-12">
            <label for="emailTitle">Email Template Name</label>
            <div class="form-group">
                <input type="text" id="emailTitle" [(ngModel)]="emailTitle" disabled />
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <label for="emailFrom">From</label>
            <div class="form-group">
                <input type="text" id="emailFrom" [(ngModel)]="emailFrom" placeholder="From" disabled />
            </div>
        </div>
        <div class="col-6">
            <label for="emailToInput">To</label>
            <div class="form-group">
                <ng-select [items]="items$ | async"
                           [closeOnSelect]="true"
                           [multiple]="true"
                           [hideSelected]="false"
                           bindLabel="name"
                           bindValue="name"
                           [typeahead]="input$" id="emailTo" labelForId="emailToInput" [(ngModel)]="emailTo">
                </ng-select>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <label for="emailCcInput">CC</label>
            <div class="form-group">
                <ng-select [items]="items$ | async"
                           bindLabel="name"
                           bindValue="name"
                           [closeOnSelect]="true"
                           [multiple]="true"
                           [hideSelected]="false"
                           [typeahead]="input$" id="emailTemplate_CC" labelForId="emailCcInput" [(ngModel)]="emailTemplate_CC">
                </ng-select>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <label for="emailBccInput">BCC</label>
            <div class="form-group">
                <ng-select [items]="items$ | async"
                           bindLabel="name"
                           bindValue="name"
                           [closeOnSelect]="true"
                           [multiple]="true"
                           [hideSelected]="false"
                           [typeahead]="input$" id="emailTemplate_BCC" labelForId="emailBccInput" [(ngModel)]="emailTemplate_BCC">
                </ng-select>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <label for="emailSubject">Subject</label>
            <div class="form-group">
                <input type="text" id="emailSubject" [(ngModel)]="emailSubject" />
            </div>
        </div>
    </div>

        <div class="row">
            <div class="col-sm-6 text-left">
                <p *ngIf="userRoleID == 1">
                    Please Note:<br>
                    -- To add line space use Shift + Enter keys<br>
                    -- To add paragraph space use Enter key<br>
                    -- To test paragraph spacing changes use SEND TEST EMAIL<br>
                    -- To insert an image, use a complete image URL including http:// or https://<br>
                    -- The image URL must be publicly accessible to display in the email<br>
                    -- To add a hyperlink, select the text first and then use the Insert Link option<br>
                </p>
            </div>
            <div class="col-sm-6 text-right">
<button type="button" class="clickBtn " data-bs-toggle="modal" data-bs-target="#placeHolderModal" (click)="getPlaceHolderData()">Placeholders</button>
</div>
            <div class="placeholderModel" *ngIf="placeHoldersDataPop">
                <div class="modal" #placeHolderModal id="placeHolderModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
                    <div class="updateEmail-dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title" id="exampleModalLabel">Placeholder</h4>
                                    <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
                                </div>
                                <div class="modal-body placeHolderBody">
                                    <div class="row palaceHolderRows" *ngFor="let item of placeHoldersData">
                                        <div class="col-md-5">
                                            {{item.EmailTemplatePlaceholders_FieldName}}
                                        </div>
                                        <div class="col-md-1 col-sm-1">:</div>
                                        <div class="col-md-6">
                                            {{item.EmailTemplatePlaceholders_Name}}
                                        </div>
                                    </div>

                                </div>
                                <div class="modal-footer">  
                                    <button type="button" class="btn btn-default editEmailSaveBtn" data-bs-dismiss="modal">OK </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
        <div>
            <!-- WYSIWIG Editor-->
             <app-rich-text-editor [editorData]="editorData" [Module]="ModuleName" (newItemEvent)="SaveData($event)"></app-rich-text-editor> 
        </div>

        <!-- modal for save email -->
        <div class="placeholderModel updateEmail">
            <div class="modal" id="saveEmailModal" tabindex="-1" role="dialog" aria-labelledby="saveEmailModalLabel">
                <div class="updateEmail-dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="saveEmailModalLabel">Success</h5>
                                <button type="button" class="close" data-bs-dismiss="modal" (click)="successModelOk()">&times;</button>
                            </div>
                            <div class="modal-body placeHolderBody" *ngIf="saveEmailTemplate">
                                <h5>Your Email has been saved successfully.</h5>

                            </div>
                            <div class="modal-body placeHolderBody" *ngIf="!saveEmailTemplate">
                                <h5>Test Email has been sent successfully.</h5>

                            </div>
                            <div class="modal-footer" *ngIf="saveEmailTemplate">
                                <button type="button" class="btn btn-default editEmailSaveBtn" (click)="successModelOk()" data-bs-dismiss="modal">OK </button>
                            </div>
                            <div class="modal-footer" *ngIf="!saveEmailTemplate">
                                <button type="button" class="btn btn-default editEmailSaveBtn" data-bs-dismiss="modal">OK </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="updatedContentPreview" *ngIf="showPreview"><div [innerHTML]="updatedContent | safeHtml "></div></div>
        <div class="col-12 text-right marT10">
            <button type="button" (click)="successModelOk()" class="clickBtn marR10">Cancel</button>
            <button type="button" class="clickBtn marR10" (click)="saveData()">Save Email</button>
            <button type="button" class="clickBtn marR10" (click)="previewInOutlook()">Preview</button>
            <button type="button" class="clickBtn" (click)="testMail()">Send Test Email</button>
        </div>
        <div class="col-12 text-left marT10"><p>Last Modified by {{modifiedBy}} {{modifiedTime}}</p></div>
    </div>
<!-- Error Modal -->
<div class="updateEmail">
    <div class="modal" #manageEmail id="saveEmailPopup" tabindex="-1" role="dialog"
         aria-labelledby="saveEmailPopupModalLabel">
        <div class="createClient-dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="saveEmailPopupModalLabel">Error</h5>
                        <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <p>
                                Please add at least 1 recipient
                            </p>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default clickBtn" data-bs-dismiss="modal">
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
